// extracted by mini-css-extract-plugin
module.exports = {"Product":"ProductRanQiGuo_Product__UiDGa"};